/**
 * switchWorkspace — clears workspace + project state, invalidates all
 * fetch cache queries (stale on next read), loads the new workspace.
 */

const WORKSPACE_KEYS = new Set(['workspace', 'workspaceMembers', 'workspaceIntegrations', 'workspaceBilling'])
const PROJECT_KEYS = new Set(['project', 'projectComponents', 'projectPages', 'projectState'])

/**
 * @param {object} state           - DOMQL root state
 * @param {object} sdk             - SDK instance (must have workspace.getWorkspace)
 * @param {object} queryClient     - @symbo.ls/fetch queryClient
 * @param {string} newWorkspaceId  - target workspace ID
 */
export const switchWorkspace = async (state, sdk, queryClient, newWorkspaceId) => {
  for (const k of WORKSPACE_KEYS) state[k] = null
  for (const k of PROJECT_KEYS) state[k] = null

  // Invalidate all workspace-scoped fetch cache entries.
  // Cache keys include workspace ids in params; nuking by 'workspace' prefix
  // would over-evict, so we use queryClient.invalidateQueries() to mark all
  // queries stale — they'll refetch on next read.
  queryClient.invalidateQueries()

  state.workspace = await sdk.workspace.getWorkspace(newWorkspaceId)
  localStorage.setItem('activeWorkspace', newWorkspaceId)
}
